// extracted by mini-css-extract-plugin
export default {"btn":"VerticalTabs_btn__Sudc3","line":"VerticalTabs_line__xZuk-"};